import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import 'primeicons/primeicons.css';
import CustomToastPlugin from './plugins/CustomToastPlugin';

// Remove the reference to layout.scss
// import './assets/layout/layout.scss';
import './assets/layout/flags/flags.css';

// Remove the incorrect import for the Aura theme
// import Aura from '@primevue/themes/aura';

import { createApp, reactive } from 'vue';
import router from './router/router';
import App from './App.vue';
import PrimeVue from 'primevue/config';

// import ToastService from 'primevue/toastservice';

import VueConstants from 'vue-constants';

import { FontAwesomeIcon } from './font-awesome';

// Import CSS files
import './assets/css/app.css'

router.beforeEach(function(to, from, next) {
    window.scrollTo(0, 0);
    next();
});

const app = createApp(App);

app.config.globalProperties.$appState = reactive({ inputStyle: 'outlined' });

app.use(PrimeVue);

// app.use(ToastService);
app.use(router);
app.use(VueConstants);
app.use(CustomToastPlugin);

app.component('font-awesome-icon', FontAwesomeIcon);

app.component('VueDatePicker', VueDatePicker);

app.mount('#app');
